import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "waiwai-comic-favorites";

function readFavorites(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(readFavorites());
  }, []);

  const persist = useCallback((next: string[]) => {
    setFavorites(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      /* ignore storage failures */
    }
  }, []);

  const toggleFavorite = useCallback(
    (comicId: string) => {
      const next = favorites.includes(comicId)
        ? favorites.filter((id) => id !== comicId)
        : [...favorites, comicId];
      persist(next);
      return next.includes(comicId);
    },
    [favorites, persist]
  );

  const isFavorite = useCallback(
    (comicId: string) => favorites.includes(comicId),
    [favorites]
  );

  return { favorites, toggleFavorite, isFavorite };
}